import React, { useState } from 'react'

import Modal from '../../components/Modal'
import { getMeterIcon } from '../Dashboard'
import {ConfirmButton} from '../../components/BasicButton'
import "../assets/scss/DashboardSettings.scss"
import DropdownMenu from "../../components/DropdownMenu";

/**
 * @typedef Props
 * @property {import('../Dashboard').Dashboard} Props.dashboard
 * @property {import('../Dashboard').ViewPreferences} Props.viewPreferences
 * @property {(newOrder: string[]) => void} Props.onClose
 */

/**
 * @param {Props} props 
 */
export function DashboardMainPrjAddModal(props) {
    const {
        all_meters,
        subprojects,
        viewPreferences,
    } = props

    const [selectedMeters, setSelectedMeters] = useState(selectedMetersFromViewPreferences)
    const [selectedSubproject, setSelectedSubproject] = useState(subprojects ? subprojects[0] : '')

    function selectedMetersFromViewPreferences() {
        let meters = []
        if (viewPreferences.hasOwnProperty('meters')) {
            meters = all_meters.filter(meter => viewPreferences.meters.find(view_meter => view_meter[0] === meter.project_id && view_meter[1] === meter.obj_id))
        }
        return meters
    }

    function selectMeter(meter, select) {
        let selected_meters
        if (select) {
            selected_meters = [meter, ...selectedMeters]
        } else {
            selected_meters = selectedMeters.filter(s_meter => meter.obj_id !== s_meter.obj_id || meter.project_id !== s_meter.project_id)
        }
        setSelectedMeters(selected_meters)
    }

    function renderSelectedMeters() {
        return selectedMeters
            .filter(s_meter => all_meters.find(meter => meter.obj_id === s_meter.obj_id && meter.project_id === s_meter.project_id))
            .map(meter => renderButton(meter, false))
    }

    function renderSelectedSubprojectMeters() {
        return all_meters
            .filter(meter => {
                return meter.project_id.split(';')[1] === selectedSubproject.project_id
                    && ! selectedMeters.find(s_meter => meter.obj_id === s_meter.obj_id && meter.project_id === s_meter.project_id)
            })
            .map(meter => renderButton(meter))
    }

    function renderButton(meter, select= true) {
        return <div
                key={(select ? '' : 'selected-') + meter.obj_id}
                className="box element-set-v dashboard-settings_draggable"
                onClick={(e) => selectMeter(meter, select)}
            >
            <img
                src={getMeterIcon(meter.obj_type)}
                alt={meter.obj_type}
            />
            <span>{meter.text}</span>
            {!select ? <span className={"text-xs"}>{meter.project_settings.text}</span> : null}
        </div>
    }

    function formatSubprojectList(){
        return subprojects.map(subproject => {
            let subproject_meters = all_meters.filter(meter => meter.project_id.split(';')[1] === subproject.project_id)
            if (subproject_meters.length < 1) {
                return {}
            }
            return {
                value: subproject,
                text: subproject.text + ' (' + subproject_meters.length + ')'
            }
        }).filter(obj => obj !== {})
    }

    return <Modal header="Lisää/poista kuvaajia" onClose={() => props.onClose(selectedMeters)} showCloseButton>
        <section>
            <DropdownMenu
                values={formatSubprojectList()}
                currentValue={selectedSubproject}
                onSelect={(val) => {
                    setSelectedSubproject(val)
                }}
                tooltip={["Osaprojektit"]}
                className="width-100 width-50_lg"
            />
            <div className={"grid-container grid-2 flex-gap-lg margin-top"}>
                <div>
                    <h3>Valitse kuvaajat</h3>
                    <div className="grid-container grid-1 grid-3_lg">
                        {renderSelectedSubprojectMeters()}
                    </div>
                </div>
                <div>
                    <h3>Valitut kuvaajat</h3>
                    {selectedMeters.length > 0 ? <div className="grid-container grid-1 grid-3_lg">
                        {renderSelectedMeters()}
                    </div> : <p>Ei valittuja.</p>}
                </div>
            </div>
        </section>
        <footer className={"popup-footer"}>
            <div className={"btn-set"}>
                <ConfirmButton
                    label={"Valmis"}
                    action={()=> props.onClose(selectedMeters)}
                />
            </div>
        </footer>
    </Modal>
}
